import { render, staticRenderFns } from "./UnloadingCargos.vue?vue&type=template&id=6e83d4c6&scoped=true&"
import script from "./UnloadingCargos.vue?vue&type=script&lang=js&"
export * from "./UnloadingCargos.vue?vue&type=script&lang=js&"
import style0 from "./UnloadingCargos.vue?vue&type=style&index=0&id=6e83d4c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e83d4c6",
  null
  
)

export default component.exports